import axios from "axios";
const baseUrl = "/api/backend/page";

// This file specifically will be for form (creation/assessment) HTTP request
export const form = {
  get: (page, params) => axios.get(`${baseUrl}/${page}`, params), // Get data for specific page
  put: ({ payload, page, params }) =>
    axios.put(`${baseUrl}/${page}`, payload, { params }),
  post: ({ payload, page, params }) =>
    axios.post(`${baseUrl}/${page}`, payload, { params }),
};
